import * as React from 'react';
import { styled } from '../../theme';
import { PropsWithChildren } from 'react';

export interface FooterTextWidgetProps {
  className?: any;
}

export const FooterTextWidget: React.FC<PropsWithChildren<FooterTextWidgetProps>> = (props) => {
  return <S.Container className={props.className}>{props.children}</S.Container>;
};

const BASE_LABEL = 'footer-text-widget';
namespace S {
  export const Container = styled.div`
    label: ${BASE_LABEL};
    color: ${(p) => p.theme.text.secondary};
    font-size: 12px;

    & a {
      color: ${(p) => p.theme.text.secondary};
      font-weight: bold;
      text-decoration: none;
    }
  `;
}
